export const UerCopyPagesList = [
    {
        id: 'calculationCard',
        label: 'Карточка расчета НМЦ',
    },
    {
        id: 'collectionPrices',
        label: 'Сборник расценок',
    },
    {
        id: 'collectionRatios',
        label: 'Сборник коэффициентов',
    },
    {
        id: 'calculationStructure',
        label: 'Структура расчета',
    },
    {
        id: 'workVolume',
        label: 'ВОР',
    },
    {
        id: 'calculationMtr',
        label: 'Ведомость МТР',
    },
    {
        id: 'calculationLimitedCosts',
        label: 'Доп.транспорт и лимитированные затраты',
    },
    {
        id: 'calculationOthers',
        label: 'Прочие затраты',
    },
];
